import api from '~api'
import moment from 'moment'
export const url = `/lectures`

export async function postTeacherLogin({ id, password }) {
  const {
    data
  } = await api.post(`${url}/login`, {
    email: id,
    password
  })
  return {
    token: data.access_token,
    token_expired_at: moment().add(data.expires_in, 's')._d
  }
}

export async function getTeacherLogout() {
  const {
    data
  } = await api.post(`${url}/logout`)
  return data
}

export async function getTeacher() {
  const {
    data
  } = await api.get(`${url}`)

  const response = data.data

  const teacher = {
    teacher_department_id: response.department_of_id,
    teacher_department_name: response.department_of_name,
    teacher_email: response.email,
    teacher_id: response.id,
    teacher_name: response.name,
    teacher_phone_number: response.tel,
  }

  return teacher
}

export async function getTeacherReminder() {
  const {
    data
  } = await api.get(`/getReminder`)

  return data
}

export async function putTeacher(profile) {
  const request = {
    name: profile.name,
    department_of_id: profile.department_of_id,
    tel: profile.tel,
  }
  console.log(request);
  return {};
  if (profile.password) {
    putStudentPassword(profile)
  }

  const {
    data
  } = await api.put(`${url}`, request)

  return data
}

export async function putTeacherPassword(profile) {
  const passwordRequest = {
    password: profile.password,
    password_confirmation: profile.password_confirmation
  }
  const {
    data
  } = await api.put(`${url}/reset-password`, passwordRequest)

  return data
}

export async function sendInternForm({ type, params }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/sendForm`, params)

  return data
}

export async function getInternForm({ type, params }) {
  const {
    data
  } = await api.get(`${url}/form/${type}/getForm`, { params })

  const formData = data.data;

  return {
    formData
  }
}

export async function getFileNameList({ type, params }) {
  const {
    data
  } = await api.get(`${url}/form/${type}/getFileNameList`, { params });

  const fileNameList = data.data;

  return {
    fileNameList,
  }
}

export async function deleteInternFile({ type, form_id }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/deleteFile`, { id: form_id });

  return data
}

export async function uploadInternFormFile({ type, params }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/setFile`, params);

  return data
}

export async function downloadInternFormFile({ type, form_id }) {
  const {
    data,
    headers
  } = await api.post(`${url}/form/${type}/download`, { id: form_id }, { responseType: 'blob' ,  headers: {
    'No-Success-Notification': 'true'
  }});

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');

  // create file link in browser's memory
  link.href = URL.createObjectURL(data);

  // get file name from content-disposition
  var filename = "";
  let disposition = headers['content-disposition'];
  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename\*?=([^']*'')?([^;]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[2]) {
      filename = decodeURIComponent(matches[2].replace(/['"]/g, ''));
    }
  }

  // setup file name
  filename = filename.replace(/.*\//g, '').replace(/^[^_]*_[^_]*_/,'');
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);

  return undefined;
}

export async function getInternSearchOptions() {
  const {
    data
  } = await api.get(`${url}/getInternSearchOptions`)

  const internSearchOptions = data;

  return {
    internSearchOptions,
  }
}

export async function getInternRecordList(params) {
  const {
    data
  } = await api.get(`${url}/getInternRecordList`, { params })

  const internRecordList = data.data.map(record => {
    return {
      year: record.year,
      enterprise_id: record.enterprise_id,
      enterprise_name: record.enterprise_name,
      department: record.department,
      department_id: record.department_id,
      student_id: record.student_id,
      student_name: record.student_name,
      student_account: record.student_account,
    };
  });

  return {
    internRecordList,
  }
}

export async function getEnterprisesList(keyword) {
  let params = { search: keyword };
  const {
    data
  } = await api.get(`${url}/getInternCompany`, { params })

  const enterprisesList = data.data.map(enterprise => {
    return {
      enterprise_id: enterprise.id,
      enterprise_name: enterprise.name,
    };
  });

  return {
    enterprisesList,
  }
}

export async function getStudentInternRecordList(student_id) {
  const {
    data
  } = await api.get(`${url}/getStudentRecord/${student_id}`)

  const studentInternRecordList = data.data.map(enterprise => {
    return {
      enterprise_id: enterprise.id,
      enterprise_name: enterprise.name,
    };
  });

  return {
    studentInternRecordList,
  }
}
